module.exports = __webpack_public_path__ + "img/leader-3.7f6867b8.png";